var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHailstorm = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.3,33.2c-1.4,3.5-3.5,6.7-6.3,9.3l-3-3.1c2.7-2.6,4.7-5.8,5.8-9.4c4.3-13.9-6.2-28-20.7-28c-7.8,0-14.9,4.2-18.7,10.8 c2.3,1.1,4.4,2.6,6.2,4.5l-3.1,3C51.4,17,46.9,15,42.1,15c-8.1,0-15,5.6-16.8,13.3c2.9,0.5,5.8,1.6,8.3,3.3l-2.4,3.6 c-2.8-1.9-6.2-2.9-9.6-2.9C12,32.3,4.2,40,4.2,49.6S12,66.9,21.5,66.9h67c9.5,0,17.3-7.8,17.3-17.3 C105.9,42.1,101.2,35.6,94.3,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,96.4c-2.8-2.2-6.9-1.7-9.1,1.1v0c-2.2,2.8-1.7,6.9,1.1,9.1c2.8,2.2,6.9,1.7,9.1-1.1 C18.1,102.6,17.6,98.6,14.7,96.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 81,
    transform: "matrix(0.6153 -0.7883 0.7883 0.6153 -56.5711 50.3935)",
    width: 19.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2,94.2c-2.8-2.2-6.9-1.7-9.1,1.1v0c-2.2,2.8-1.7,6.9,1.1,9.1c2.8,2.2,6.9,1.7,9.1-1.1C37.5,100.5,37,96.4,34.2,94.2z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 79.9,
    transform: "matrix(0.6153 -0.7883 0.7883 0.6153 -48.5592 64.655)",
    width: 16.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,94.2c-2.8-2.2-6.9-1.7-9.1,1.1v0c-2.2,2.8-1.7,6.9,1.1,9.1c2.8,2.2,6.9,1.7,9.1-1.1 C78.6,100.5,78.1,96.4,75.3,94.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.7,
    y: 79.9,
    transform: "matrix(0.6153 -0.7883 0.7883 0.6153 -32.7538 97.0457)",
    width: 16.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7,96.4c-2.8-2.2-6.9-1.7-9.1,1.1v0c-2.2,2.8-1.7,6.9,1.1,9.1c2.8,2.2,6.9,1.7,9.1-1.1C57,102.6,56.5,98.6,53.7,96.4z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.6,
    y: 81,
    transform: "matrix(0.6153 -0.7883 0.7883 0.6153 -41.5962 81.0775)",
    width: 19.4,
    height: 4.3
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHailstorm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hailstorm.a809f569.svg";
export { ForwardRef as ReactComponent };